import ajax from './index'
import api from './api'
import util from '../utils/utils'
import store from '../store/index'
import type from '../store/type'

export default {
    async login(user, pass) {
        let res = await ajax.request1({ url: api.login, method: "POST", data: { job_number: user, password: pass } })
        if (res.data.status == 1) {
            util.setStorage('userInfo', res.data.data)
            store.commit(type.ACTIONS.SET_USERINFO, res.data.data)
        }
        return res
    },
    async findOut(data) {
        return await ajax.request1({ url: api.findOut, method: "POST", data: data })
    },
    async getOutByNo(exit_factory_no) {
        return await ajax.request1({ url: api.getOutByNo, params: { exit_factory_no: exit_factory_no } })
    },

    // 订单号或条形码查询
    async queryOrder(clothTerm) {
        return await ajax.request1({ url: api.queryOrder, method: 'POST', data: { clothTerm: clothTerm } })
    },
    //点击衣物信息查询工厂和门店操作记录
    async orderAbout(code) {
        return await ajax.request1({ url: api.orderAbout, params: { code: code } })
    },

    //衣物预警
    async warn(data) {
        return await ajax.request1({ url: api.warn, method: 'POST', data: data })
    },

    //业绩查询
    async workCount(data) {
        return await ajax.request1({ url: api.workCount, method: 'POST', data: data })
    },

    //掉标衣物查看
    async findLossBid(data) {
        return await ajax.request1({ url: api.findLossBid, method: 'POST', data: data })
    },

    //掉标衣物匹配
    async matchBid(data) {
        return await ajax.request1({ url: api.matchBid, method: 'POST', data: data })
    },

    //员工的岗位操作权限
    async operate(type) {
        let res = await ajax.request1({ url: api.operate, method: 'POST', data: { type: type } })
        let rel = res.data.data
        rel.map((v, i) => {
            rel[i].title = v.name
        })
        return rel
    },

    // 衣物工序（出厂单独接口）
    async changeClothProcess(data) {
        return await ajax.request1({ url: api.changeClothProcess, method: 'POST', data: data })
    },

    // 衣物出厂
    async outFactory(data) {
        return await ajax.request1({ url: api.outFactory, method: 'POST', data: data })
    },

    // 今日工作件数
    async countPosition(status) {
        return await ajax.request1({ url: api.countPosition, method: 'POST', data: { status: status } })
    },

    // 确认出厂
    async outSys() {
        return await ajax.request1({ url: api.outSys, method: 'POST' })
    },

    // 公共接口
    //获取门店员工信息
    async getShopMember(shop_id) {
        return await ajax.request1({ url: api.getShopMember, params: { shop_id: shop_id } })
    },
    //获取门店信息
    async allShop() {
        return await ajax.request1({ url: api.allShop })
    },
    //获取岗位信息
    async allPosition() {
        return await ajax.request1({ url: api.allPosition })
    },
    //获取工厂所有员工信息
    async allPeople() {
        return await ajax.request1({ url: api.allPeople })
    },
    //获取颜色
    async getShopColor() {
        return await ajax.request1({ url: api.getShopColor })
    },
    //获取驾驶员数据接口
    async allDriver() {
        return await ajax.request1({ url: api.allDriver })
    },
    //获取驾驶员数据接口
    async returnWhy() {
        return await ajax.request1({ url: api.returnWhy })
    },
    //添加返工
    async insertReturn(params) {
        return await ajax.request1({ url: api.insertReturn, method: 'POST', data: params })
    },
    //添加返工
    async addExtra(params) {
        return await ajax.request1({ url: api.addExtra, method: 'POST', data: params })
    },
    // 返工记录列表接口
    async returnList(params) {
        return await ajax.request1({ url: api.returnList, method: 'POST', data: params })
    },
    // 衣物补款列表接口
    async extraList(params) {
        return await ajax.request1({ url: api.extraList, method: 'POST', data: params })
    },
    async sureAccept(params) {
        return await ajax.request1({ url: api.sureAccept, method: 'POST', data: params })
    },
    // 单个门店营业额查询
    async shopMoney(params) {
        return await ajax.request1({ url: api.shopMoney, method: 'POST', data: params })
    },
    // 门店类型营业额统计
    async shopTypeMoney(params) {
        return await ajax.request1({ url: api.shopTypeMoney, method: 'POST', data: params })
    },

    // 门店每日收衣统计
    async shopClothCount(params) {
        return await ajax.request1({ url: api.shopClothCount, method: 'POST', data: params })
    },

    // 工厂总检数据查询
    async checkClothCount(params) {
        return await ajax.request1({ url: api.checkClothCount, method: 'POST', data: params })
    }
}